import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { Heading, HeadingTypes } from '../../components';
import { ChangeableAvatar } from '../../components/ChangeableAvatar';
import { defaultScale } from '../../utils/scaling';
import Theme from '../../theme';
import { GymResolver } from '../../services';

export class ProfileDisplay extends Component {
  render() {
    const { userProfile, navigation } = this.props;
    const gym = GymResolver.getByName(userProfile.gymName);

    return (
      <View style={styles.profileContainer}>
        <ChangeableAvatar
            showChangeText={false}
            size={70}
            userProfile={userProfile}
            navigation={navigation}
          />
        <View style={styles.infoContainer}>
          <Heading
            style={styles.headerName}
            title={userProfile.fullname}
            headingType={HeadingTypes.HEADING_ONE}
          />
          <Heading
            style={[Theme.textStyle.bodyCopyReg, styles.headerGym]} 
            title={gym.displayName}
            headingType={HeadingTypes.HEADING_THREE}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  profileContainer: {
    padding: defaultScale(15),
    paddingTop: defaultScale(5),
    flexDirection: 'row',
    alignItems: 'center',
  },
  infoContainer: {
    flexDirection: 'column',
  },
  headerName: {
    fontSize: 25,
    paddingLeft: 15,
    color: Theme.CHARCOAL,
    textAlign: 'center',
    fontFamily: Theme.CustomBold,
  },
  headerGym: {
    fontWeight: '400',
    fontSize: 15,
    paddingLeft: 15,
    color: Theme.CHARCOAL,
  },
  userIconText: {
    fontSize: defaultScale(25),
    fontFamily: Theme.Weight700,
  }
});
